export const DONATION_MODES = {
  CHATGPT_ONLY: 'CHATGPT_ONLY',
  TAKEOUT_ONLY: 'TAKEOUT_ONLY',
  BOTH: 'BOTH',
};

// Adjust this flag to control which donation flows are available.
// Set to BOTH to enable unified ChatGPT + Google Takeout donation
export const DONATION_MODE = DONATION_MODES.BOTH;

export const isChatgptEnabled = () =>
  DONATION_MODE === DONATION_MODES.CHATGPT_ONLY || DONATION_MODE === DONATION_MODES.BOTH;

export const isTakeoutEnabled = () =>
  DONATION_MODE === DONATION_MODES.TAKEOUT_ONLY || DONATION_MODE === DONATION_MODES.BOTH;
